import { useEffect, useState } from "react";
import { AlertOctagon } from "lucide-react";
import { api } from "../services/api";
import { formatDateTime } from "../lib/formatters";

const POLL_MS = 60_000;

// Account-wide AI outage (balance, quota or API key). Shown on every page so a
// paused background queue is noticed long before inquiries pile up.
export default function AiOutageBanner({ userId }) {
  const [alert, setAlert] = useState(null);

  useEffect(() => {
    if (!userId) return undefined;
    let cancelled = false;
    const load = async () => {
      if (document.hidden) return;
      try {
        const result = await api.aiProviderAlert();
        if (!cancelled) setAlert(result?.alert || null);
      } catch {
        // Keep the last known state; a failed poll is not proof of recovery.
      }
    };
    load();
    const timer = window.setInterval(load, POLL_MS);
    document.addEventListener("visibilitychange", load);
    return () => {
      cancelled = true;
      window.clearInterval(timer);
      document.removeEventListener("visibilitychange", load);
    };
  }, [userId]);

  if (!alert) return null;
  const minutes = Math.max(1, Math.round((alert.probe_interval_seconds || 600) / 60));
  return (
    <div className="ai-outage-banner" role="alert">
      <AlertOctagon size={18} aria-hidden="true" />
      <div>
        <strong>AI 服务不可用，后台自动处理已暂停</strong>
        <span>
          {alert.retry_window_open
            ? `自 ${formatDateTime(alert.first_seen_at)} 起调用失败，${alert.paused_jobs} 封询盘在排队。系统每 ${minutes} 分钟自动探测，恢复后会自动继续处理，无需手动重试。`
            : `已连续失败超过 ${alert.max_hours} 小时，系统停止自动重试，新失败的询盘会转为待处理。`}
          请检查 AI 服务商账户余额、配额和 API Key。
        </span>
        {alert.message && <small title={alert.message}>服务商返回：{alert.message}</small>}
      </div>
    </div>
  );
}
